module.exports = __webpack_public_path__ + "img/discuss-screen-dark-es.eaba3a78.webp";